import { a as n } from "./emotion-css-create-instance.esm.js";
const { css: e, sheet: r } = n({
  key: "jwplayer"
});
r.isSpeedy = !0;
const t = {};
t.container = e({
  " .jw-controls .jw-controls-right": {
    position: "absolute",
    top: 0,
    right: "auto",
    left: 0
  },
  " .jw-dock-button .jw-overlay": {
    right: "auto"
  },
  " .jw-title": {
    zIndex: 100
  },
  " .jw-plugin-sharing": {
    zIndex: 1
  },
  " .jw-plugin-related": {
    zIndex: 1
  },
  " .jw-state-playing.jw-flag-user-inactive .webedia-postroll-currently-playing": {
    display: "none"
  },
  " .jw-sharing-container": {
    zIndex: 10
  },
  " .jw-related-container": {
    zIndex: 10
  }
});
t.webediaPlayerBannerContainer = e({
  fontFamily: "Arial",
  fontSize: "13px",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: "40px",
  left: 0,
  pointerEvents: "none"
});
const i = {
  position: "absolute",
  pointerEvents: "auto",
  color: "#fff",
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  "&:empty": {
    display: "none"
  }
};
t.webediaPlayerBannerLeft = e({
  ...i,
  top: 0,
  left: 0
});
t.webediaPlayerBannerCenter = e({
  ...i,
  top: 0,
  right: "120px",
  left: "120px"
});
t.webediaPlayerBannerRight = e({
  ...i,
  top: 0,
  right: 0
});
t.webediaPlayerBannerBottomRight = e({
  ...i,
  right: 0,
  bottom: 0
});
t.webediaPostrollCurrentlyPlaying = e({
  padding: "1.5em",
  cursor: "pointer"
});
t.webediaPostrollPreview = e({
  overflow: "auto",
  padding: "1em"
});
t.webediaPostrollPreviewMessage = e({
  float: "left",
  marginRight: "0.5em",
  textAlign: "left"
});
t.webediaPostrollPreviewClose = e({
  float: "right",
  cursor: "pointer"
});
t.webediaPlayerCloseNextVideo = e({
  with: "14px",
  height: "14px"
});
var a = /* @__PURE__ */ ((o) => (o.PLAYING_ADVERTISEMENT = "playing-advertisement", o.PLAYING_VIDEO = "playing-video", o.PLAYING_POSTROLL = "playing-postroll", o.INITIALISING = "initialising", o.IDLE = "idle", o.PAUSED = "paused", o))(a || {});
const s = [
  "playing-advertisement",
  "playing-video",
  "playing-postroll"
  /* PLAYING_POSTROLL */
];
export {
  s as P,
  a as S,
  t as s
};
